import ManagerRepository from 'coreClasses/ManagerRepository';
import Manager from 'coreClasses/Manager';
import {configureStore, EnhancedStore} from '@reduxjs/toolkit';
import customerReducer from 'coreStore/data/customer';
import basketReducer from 'coreStore/data/basket';
import productReducer from 'coreStore/data/products';
import ordersReducer from 'coreStore/data/orders';
import promotionReducer from 'coreStore/data/promotions';
import giftCertificateReduser from 'coreStore/data/giftCertificates';
import productSearchResultReducer from 'coreStore/data/productSearchResult';
import customerProductListsReducer from 'coreStore/data/customerProductLists';
import configurationsReducer from 'coreStore/data/configurations';
import categoriesReducer from 'coreStore/data/categories';
import UIReducer from 'coreStore/data/ui';
import pageReducer from 'coreStore/data/page';

/**
 * Represents StoreMgr
 */
class StoreMgr extends Manager {
	private store: EnhancedStore;

	/**
	 * @constructor
	 * @param {ManagerRepository} managerRepository - ManagerRepository instance
	 * @param {Object} initialState - initial redux state
	 */
	constructor(managerRepository: ManagerRepository, initialState: object | null) {
		super(managerRepository);

		if (initialState) {
			this.createStore(initialState);
		}
	}

	/**
	 * Returns store (creates if not created yet)
	 * @returns {EnhancedStore}
	 */
	getStore(): EnhancedStore {
		if (!this.store) {
			this.createStore();
		}

		return this.store;
	}

	/**
	 * Creates store
	 * @param {Object} initialState Initial store state
	 */
	createStore(initialState: object = {}) {
		const reducer = {
			customer: customerReducer,
			customerProductLists: customerProductListsReducer,
			basket: basketReducer,
			products: productReducer,
			orders: ordersReducer,
			promotions: promotionReducer,
			productSearchResult: productSearchResultReducer,
			configurations: configurationsReducer,
			categories: categoriesReducer,
			giftCertificate: giftCertificateReduser,
			ui: UIReducer,
			page: pageReducer,
		};

		this.store = configureStore({
			reducer,
			preloadedState: initialState,
		});
	}
}

export default StoreMgr;
